/* eslint-disable import/prefer-default-export, no-underscore-dangle, no-console */
import React, { useContext, useState } from 'react';
import { Collapse, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import ReactDOM from 'react-dom';
import { ReactComponent as ExpandLess } from '../../../assets/images/expand-less.svg';
import { ReactComponent as ExpandMore } from '../../../assets/images/expand-more.svg';
import { ReactComponent as PdfIcon } from '../../../assets/images/menu-icons/icon-pdf.svg';
import { replaceText, translationsForPdf, importData } from '../../../utils';
import { companyName } from '../../../constants';
import AppContext from '../../../context/AppContext';
import Hays from '../../../templates/hays/Hays';
import templates from '../../../templates';

const createModalPdf = (text) => {
  const messageElement = document.createElement('div');
  messageElement.innerText = text;
  Object.assign(messageElement.style, {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    color: 'white',
    padding: '20px',
    borderRadius: '8px',
    zIndex: 1000,
    textAlign: 'center',
  });

  return messageElement;
};

export const PdfItems = ({ spinner, handleClose }) => {
  const [openPdf, setOpenPdf] = useState(false);
  const context = useContext(AppContext);
  const {
    state: { resumeItems, selectedCvId, ownCvId, theme },
    dispatch,
  } = context;

  const ensureActiveResumeLoaded = () => {
    const activeId = selectedCvId || ownCvId;
    if (!activeId || !resumeItems || resumeItems.length === 0) {
      return;
    }
    const activeResume =
      resumeItems.find((item) => item.id === activeId || item._id === activeId) || resumeItems[0];
    if (activeResume) {
      importData(dispatch, { data: { ...activeResume } });
    }
  };

  const waitForRender = (ms = 500) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  const injectHaysPrintStyles = () => {
    const css = `
      @page { size: A4; margin: 30px 0 22px 0; }
      @media print {
        body::before {
          content: '';
          position: fixed;
          top: 0; left: 26px;
          width: calc(100% - 52px);
          height: 2px;
          background-color: #c63031;
          z-index: 9999;
          visibility: visible;
        }
      }
    `;
    const style = document.createElement('style');
    style.id = 'hays-print-overrides';
    style.innerHTML = css;
    document.head.appendChild(style);
    return style;
  };

  const removeHaysPrintStyles = (styleEl) => {
    if (styleEl && styleEl.parentNode) {
      styleEl.parentNode.removeChild(styleEl);
    }
  };

  const handleHaysPdf = async () => {
    ensureActiveResumeLoaded();
    spinner.start();
    const messageElement = createModalPdf('Please save HAYS PDF');
    document.body.appendChild(messageElement);

    const printPage = document.getElementById('printPage');
    const originalHTML = printPage.innerHTML;

    ReactDOM.render(
      <AppContext.Provider value={context}>
        <Hays />
      </AppContext.Provider>,
      printPage,
    );

    document.querySelectorAll('.hide-on-print').forEach((el) => {
      el.style.display = 'none';
    });

    const styleEl = injectHaysPrintStyles();

    await new Promise((r) => setTimeout(r, 1000));

    window.print();
    document.body.removeChild(messageElement);

    removeHaysPrintStyles(styleEl);
    ReactDOM.unmountComponentAtNode(printPage);
    printPage.innerHTML = originalHTML;
    spinner.stop();
    handleClose();
  };

  const handlePdf = async () => {
    ensureActiveResumeLoaded();

    const messageElement = createModalPdf('Please save document as PDF');
    document.body.appendChild(messageElement);

    await waitForRender();
    spinner.start();

    const printPage = document.getElementById('printPage');
    const originalHTML = printPage.innerHTML;

    const currentTemplate = templates.find((x) => theme?.layout?.toLowerCase() === x.key);
    const TemplateComponent = currentTemplate?.component;
    ReactDOM.render(
      <AppContext.Provider value={context}>
        {TemplateComponent ? <TemplateComponent /> : null}
      </AppContext.Provider>,
      printPage,
    );

    printPage.querySelectorAll('.hide-on-print').forEach((el) => {
      el.style.display = 'none';
    });

    await new Promise((resolve) => setTimeout(resolve, 1000));

    window.print();

    document.body.removeChild(messageElement);

    ReactDOM.unmountComponentAtNode(printPage);
    printPage.innerHTML = originalHTML;

    spinner.stop();
    handleClose();
  };

  const handleRusPdf = async () => {
    ensureActiveResumeLoaded();

    const messageElement = createModalPdf('Пожалуйста, сохраните документ как PDF');
    document.body.appendChild(messageElement);

    await waitForRender();
    spinner.start();

    const printPage = document.getElementById('printPage');
    const originalHTML = printPage.innerHTML;

    const currentTemplate = templates.find((x) => theme?.layout?.toLowerCase() === x.key);
    const TemplateComponent = currentTemplate?.component;
    ReactDOM.render(
      <AppContext.Provider value={context}>
        {TemplateComponent ? <TemplateComponent /> : null}
      </AppContext.Provider>,
      printPage,
    );

    let htmlContent = printPage.innerHTML;
    htmlContent = replaceText(htmlContent, translationsForPdf);
    printPage.innerHTML = htmlContent;

    printPage.querySelectorAll('.hide-on-print').forEach((el) => {
      el.style.display = 'none';
    });

    await new Promise((resolve) => setTimeout(resolve, 1000));

    window.print();

    document.body.removeChild(messageElement);

    ReactDOM.unmountComponentAtNode(printPage);
    printPage.innerHTML = originalHTML;

    spinner.stop();
    handleClose();
  };

  const handleClickPdf = () => {
    setOpenPdf(!openPdf);
  };

  return (
    <>
      <ListItem
        button
        onClick={handleClickPdf}
        style={{ gap: '8px', padding: '4px 10px', borderBottom: !openPdf && '1px solid #EDF2F7' }}
      >
        <ListItemIcon style={{ minWidth: 0 }}>
          <PdfIcon />
        </ListItemIcon>
        <ListItemText primary="Export as PDF" />
        {openPdf ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse
        in={openPdf}
        timeout="auto"
        unmountOnExit
        style={{ borderBottom: openPdf && '1px solid #EDF2F7' }}
      >
        <List component="div" disablePadding>
          <ListItem
            button
            style={{ paddingTop: 4, paddingBottom: 4, paddingLeft: 12 }}
            onClick={handlePdf}
          >
            <ListItemText style={{ textTransform: 'capitalize' }} primary={`${companyName} EN`} />
          </ListItem>
          <ListItem
            button
            style={{ paddingTop: 4, paddingBottom: 4, paddingLeft: 12 }}
            onClick={handleRusPdf}
          >
            <ListItemText style={{ textTransform: 'capitalize' }} primary={`${companyName} RU`} />
          </ListItem>
          <ListItem
            button
            style={{ paddingTop: 4, paddingBottom: 4, paddingLeft: 12 }}
            onClick={handleHaysPdf}
          >
            <ListItemText primary="HAYS" />
          </ListItem>
        </List>
      </Collapse>
    </>
  );
};
